module.exports = __webpack_public_path__ + "img/ch77.c5a108dd.png";